module.exports = __webpack_public_path__ + "img/logo.c6c6e14a.png";